export default {
  previous: "이전",
  next: "다음",
  mandatory: "필수",
  selection: "선택",
  noselection: "선택안함",
  optional: "선택",
  logo: "로고",
  logo_front: "첫화면 대형로고",
  favicon: "파비콘",
  mynotes: "나의 메모",
  enteryoursearchterm: "검색어를 입력하세요",
  search: "검색",
  favorites: "즐겨찾기",
  backgrounds: "배경",
  map: "지도",
  all: "전체",
  layers: "레이어",
  layer_detail_edit: "레이어 상세/수정",
  sv_detail_edit: "거리뷰 상세/수정",
  od_detail_edit: "객체탐지 상세/수정",
  noresultsfound: "검색결과가 없습니다.",
  pleaseconfirmyoursearchterm: "검색어를 확인 해주세요",
  streetview_name: "거리뷰명",
  streetview_type: "거리뷰 타입",
  streetview_list: "거리뷰 목록",
  streetview: "거리뷰",
  Streetview: "거리뷰",
  photoinquiries: "촬영문의",
  inquiries: "문의",
  openapi: "오픈API",
  tools: "도구",
  initialize: "초기화",
  roadview: "거리뷰",
  gotocoordinates: "좌표로 이동",
  screen: "화면",
  data: "데이터",
  manage: "관리",
  user: "사용자",
  admin: "관리자",
  ADMIN: "관리자",
  member: "회원",
  MEMBER: "회원",
  menu: "메뉴",
  mypage: "마이 페이지",
  tomypage: "마이 페이지로 가기",
  my: "마이",
  more: "더보기",
  domain: "도메인",
  consentForProvidingPersonalInformationToThirdParties:
    "개인정보 제3자 제공 동의",
  allmaterialsprovidedhavenolegaleffectandareforinformationalpurposesonly:
    "제공된 모든 자료는 법적 효력이 없으며 참고용 자료입니다.",
  backgroundmap: "배경지도",
  pleaseselectabackgroundmap: "배경지도를 선택해주세요",
  generalmaps: "일반지도",
  settings: "설정",
  satellitemaps: "위성지도",
  checkyourapiconnectioninformation: "API 연결정보를 확인해주세요.",
  vworld: "브이월드",
  tryaddinganewwallpaper: "새로운 배경지도를 추가 해보세요",
  maptools: "지도도구",
  measurement: "측정",
  distance: "거리",
  area: "면적",
  radius: "반경",
  slope: "경사도",
  splitscreen: "화면분할",
  singlepane: "단일창",
  mapauthoring: "지도저작",
  "2split": "2분할",
  quartering: "4분할",
  savingamapasanimage: "이미지로 지도 저장",
  themapwillbeinitializeddoyouwanttoproceed:
    "지도가 초기화 됩니다 진행하시겠습니까?",
  init_con: "초기화 하시겠습니까?",
  cancel: "취소",
  confirm: "확인",
  coordinatesystem: "좌표계",
  epsg4326: "EPSG:4326",
  epsg: "EPSG",
  xcoordinate: "X좌표",
  ycoordinate: "Y좌표",
  move: "이동",
  hangle: "수평최초각도",
  vangle: "수직최초각도",
  premise: "전제",
  places: "장소",
  places_addr: "장소/주소",
  addr: "주소",
  changecolor: "색상변경",
  viewdatadetails: "데이터 상세",
  viewsvdetails: "거리뷰 상세보기",
  datadetails: "데이터 상세보기",
  mynoteslist: "나의 메모 리스트",
  attr_field_list: "속성 필드 리스트",
  wrong_geom: "올바르지 않은 좌표값 입니다",
  number: "번호",
  registrationmodificationdate: "등록/수정일자",
  viewinanewwindow: "새창에서 보기",
  not_register_epsg: "등록되지 않은 좌표계 입니다",
  downloadingdata: "데이터 다운로드",
  groupname: "그룹명",
  groupexist: "이미 존재하는 그룹입니다",
  defaultgroups: "기본그룹",
  title: "제목",
  viewthislocationinformation: "이 위치 정보 보기",
  setasdefaultlocation: "기본 위치로 설정하기",
  viewroadview: "거리뷰 보기",
  compareroadview: "비교 거리뷰",
  measuringdistance: "거리 측정하기",
  measuretheoradius: "반경 측정하기",
  details: "상세정보",
  propertyinformation: "부동산 정보",
  architecturalinformation: "건축정보",
  coordinateinformation: "좌표정보",
  entirelayeroff: "전체 레이어 OFF",
  checkitout: "확인하세요!",
  nationalbranchlicenseplatestatus: "국가지점 번호판 현황",
  pleaseselect: "선택하세요",
  uniquenumber: "고유번호",
  statutorycode: "법정동코드",
  legalname: "법정동명",
  coloncategorycode: "대장구분코드",
  colonicclarification: "대장구분명",
  editinformation: "정보수정하기",
  checkout: "확인하세요",
  comparepastphotos: "과거 사진비교",
  leftandrightbreaks: "좌우 나누기 을 상하나누기",
  screenshot: "스크린샷",
  previouspointintime: "이전 시점",
  takenotes: "메모 작성",
  notelist: "메모 리스트",
  fullscreen: "전체화면보기",
  signinisrequired: "로그인이 필요합니다.",
  navigatetothelogin: "로그인을 위해 로그인 페이지로 이동합니다.",
  enteringnotes: "메모입력",
  selectagroup: "그룹 선택",
  enteratitleupto50characters: "제목을 입력하세요 (최대50자)",
  pleaseconfirmyourinformation: "정보를 확인 해주세요",
  contents: "내용",
  enteryourcontentupto500: "내용을 입력하세요 (최대 500)",
  coordinates: "좌표",
  addressinformation: "주소정보",
  newgroupname: "신규 그룹명",
  enteranameforyourgroupupto50characters: "그룹명을 입력하세요 (최대50자)",
  viewconnections: "연결보기",
  panleftandright: "좌우이동",
  man_ext_api: "외부API연동관리",
  managelayers: "레이어관리",
  objectdetection: "객체탐지",
  integrationstatus: "연동상태",
  enabled: "사용여부",
  managestyles: "스타일관리",
  style: "스타일",
  registermanageroadview: "거리뷰 등록/관리",
  combinedata: "데이터 합치기",
  manageroadviewnotes: "거리뷰 메모관리",
  managegroups: "그룹관리",
  integrations: "연동기관",
  download: "다운로드",
  start_download: "다운로드가 시작되었습니다",
  viewdetails: "상세보기",
  createnew: "신규생성",
  delete: "삭제",
  apikeys: "API키",
  normal: "정상",
  url: "URL",
  connectiontype: "연결 타입",
  layergroups: "레이어 그룹",
  layername: "레이어명",
  metadatadatasetname: "메타데이터 데이터 셋명",
  showlog_metadata: "로그보기 / 메타 데이터",
  metadata: "메타데이터",
  datatypes: "데이터 유형",
  deploymentregionscope: "구축 지역 / 범위",
  providerorganization: "제공 기관",
  howwebuilddata: "데이터 구축방식",
  pleaseentertheurl: "URL을 입력해주세요",
  metanm: "데이터 셋명",
  metatype: "데이터 유형",
  metaformat: "데이터 포맷",
  metacrs: "좌표계",
  metamodinterval: "갱신 주기",
  metaarea: "구축 지역 / 범위",
  metaorg: "제공 기관",
  metamethod: "데이터 구축방식",
  wms: "WMS",
  streetlightsneedrepairin2022: "2022년 가로등 수리필요",
  vectorsspaces: "벡터, 공간",
  national: "전국",
  viewlogs: "로그보기",
  viewlogdetail: "로그보기",
  enabledisable: "사용/중지",
  dataformats: "데이터 포멧",
  renewalcycles: "갱신 주기",
  apiintegration: "API 연동",
  connectwiththeregisteredapiinformation:
    "등록된 API 정보로 연동을 진행합니다.",
  shallweproceed: "진행할까요?",
  stoptheassociatedapi: "연동된 API를 중지합니다.",
  ordering: "순서관리",
  order: "순서",
  modify: "수정",
  top: "맨위로",
  up: "위로",
  groomname: "그룸명이 나와요",
  attractions: "관광시설",
  add: "추가",
  below: "아래",
  down: "아래",
  bottom: "맨아래",
  separation: "구분",
  layertype: "레이어 타입",
  layerkind: "레이어 종류",
  numberofitems: "아이템 수",
  registeringlayers: "레이어등록",
  registersv: "거리뷰등록",
  layerlist: "레이어 목록",
  layervieworder: "레이어 보기순서",
  deletelayer: "레이어 삭제",
  deletesv: "거리뷰 삭제",
  savelayer: "레이어 저장",
  savesv: "거리뷰 저장",
  enteralayername: "레이어명을 입력하세요",
  selectingalayerregistrationmethod: "레이어 등록방식 선택",
  dotmarker: "점(마커)",
  Point: "점(마커)",
  chooseaninputmethod: "입력 방식 선택",
  inputtype: "입력 방식",
  uploadfile: "파일업로드",
  uploadimgset: "이미지셋 업로드",
  no_uploaded_files: "업로드된 파일이 없습니다",
  vector: "벡터",
  line: "선 (라인)",
  directinput: "직접입력",
  directinput_shp: "직접입력(shp)",
  directinput_gpkg: "직접입력(gpkg)",
  vectortype: "벡터 타입",
  shpzipcompressedfile: "SHP (zip 압축파일)",
  encodingtype: "인코딩 타입",
  utf8: "UTF-8",
  genericimages: "일반 이미지",
  uploadingfiles: "파일업로드",
  onuploadproc: "업로드처리중",
  ospatiallyinformedimagerygeotiff: "공간 정보 이미지 (GeOTIFF)",
  dropyourfilesheretoupload: "업로드 하려면 여기에 파일을 놓으세요",
  notallowgpxonpolygon: "폴리곤 선택시에는 gpx 파일을 업로드 할 수 없습니다",
  aboutreferencecoordinates: "기준 좌표 정보",
  file: "파일",
  upload: "업로드",
  enteranameforthelayerupto50characters: "레이어명을 입력하세요 (최대50자)",
  enteranameforthesvupto50characters: "거리뷰명을 입력하세요 (최대50자)",
  pleaseconfirmyourinputinformation: "입력 정보를 확인 해주세요",
  managingstylesfieldinformation: "스타일 / 필드정보 관리",
  chooseastyle: "스타일 선택",
  inputmethod: "입력방식",
  managingpropertyfields: "속성 필드 관리",
  itemlist: "아이템 목록",
  type: "유형",
  mapeditmode: "지도편집모드",
  sharingdatadetails: "공유 / 데이터 상세보기",
  layersharingdatadetails: "레이어 공유 / 데이터 상세보기",
  svsharingdatadetails: "거리뷰 공유 / 데이터 상세보기",
  managelayersharing: "레이어 공유관리",
  managesvsharing: "거리뷰 공유관리",
  managesharing: "공유관리",
  viewinglogs: "로그보기",
  viewinglayerlogs: "레이어 로그보기",
  sldstylefiles: "SLD 스타일 파일",
  pointmarkerimages: "점(마커) 이미지",
  applying: "적용하기",
  new: "신규",
  create_move: "신규/이동",
  img: "이미지",
  pano_add: "파노라마 추가",
  pano_del: "파노라마 제거",
  pano_mod: "파노라마 수정",
  pano: "파노라마",
  legaladdress: "법정동주소",
  administrativeaddress: "행정동주소",
  youcanchangetheorderofselecteditemsbymovingthemupanddown:
    "선택한 아이템을 상하로 움직이면 순서를 변경할 수 있어요",
  aboutpropertyfields: "속성 필드 정보",
  propertyfieldnames: "속성 필드명",
  selectatype: "유형 선택",
  text: "텍스트",
  ceo: "대표이사",
  business_reg_num: "사업자 등록번호",
  mail_order_number: "통신판매번호",
  characterlimit: "글자 수 제한",
  newregistration: "신규등록",
  enteryourinformation: "정보를 입력하세요!",
  whenperformed: "수행일시",
  gotocurrentlocation: "현재 위치로 이동",
  "location.error.unavailable": "현재 위치를 가져올 수 없습니다",
  doyouwanttogotoyourcurrentlocation: "현재 위치로 이동하시겠습니까?",
  pleaseconfirmtheinformation: "정보를 확인 해주셔요",
  raster: "래스터",
  spatiallyinformedimagerygeotiff: "공간 정보 이미지 (GeOTIFF)",
  uploadfileinformation: "업로드 파일 정보",
  selectacoordinatesystem: "좌표계 선택",
  sharinglayersviewingdatainfo: "레이어 공유 / 데이터 정보보기",
  sharingsvviewingdatainfo: "거리뷰 공유 / 데이터 정보보기",
  viewingdatainformation: "데이터 정보보기",
  generalimages: "일반 이미지",
  notimgfile: "이미지 파일이 아닙니다",
  learnmore: "정보상세보기",
  general: "일반",
  name: "이름",
  hongyereservoir: "홍계 저수지",
  path: "경로",
  size: "크기",
  lastmodified: "마지막 수정",
  provider: "제공자",
  gdail: "gdail",
  informationfromyourprovider: "제공자로부터의 정보",
  zones: "영역",
  width: "너비",
  height: "높이",
  route: "길찾기",
  car: "자동차",
  walking: "도보",
  departure: "출발",
  stopover: "경유",
  destination: "도착",
  fliat3232bitfloatingpoint: "Fliat32- 32비트 부동소수점",
  gdaldriverdescription: "GDAL 드라이버 설명",
  gtiff: "GTIFF",
  gdaldrivermetadata: "GDAL 드라이버 메타데이터",
  geotiff: "GeoTIFF",
  datasetdescription: "데이터셋 설명",
  compressionbands: "압축밴드",
  accumulation: "• 축적",
  offset: "오프셋",
  additionalinformation: "추가정보",
  dimension: "차원",
  origin: "원점",
  pixelsize: "픽셀크기",
  coordinatesystemcrs: "좌표계 (CRS)",
  epsg5186kgd2002centralbelt2010: "EPSG:5186 - KGD2002 / Central Belt 2010",
  unit: "단위",
  meters: "미터",
  projections: "투영",
  theresaproblemwiththefileyouuploaded: "올바른 파일이 아닙니다.",
  determine_epsg_fail: "좌표계를 유추할 수 없습니다.",
  thefiletypeisnotsupportedortherequireddatauniquenumberismissing:
    "지원되지 않는 파일 형식이거나, 필수 데이터인 [고유번호]가 누락된 것 같습니다.",
  pleasedoublecheckthecontentsofyourfilebeforeattemptingtouploadit:
    "파일 내용을 다시 한 번 확인하신 후 업로드를 시도해 주세요.",
  deletinglayers: "레이어 삭제",
  nolayersareselected: "선택된 레이어가 없습니다.",
  nolayersareregistered: "등록된 레이어가 없습니다.",
  nopanomsg: "등록된 파노라마가 없습니다.",
  feelfreetoregisterthelayersyouwant: "원하는 레이어를 편하게 등록 해보세요",
  sharinglayers: "레이어 공유하기",
  sharingsv: "거리뷰 공유하기",
  youcanaddupto10usersatatime: "한번에 최대 10명까지 추가가 가능합니다.",
  deleteashare: "공유 삭제",
  deletetheshareduser: "공유된 사용자를 삭제합니다.",
  deleteanitem: "아이템 삭제",
  deletearegistereditem: "등록된 아이템을 삭제합니다.",
  afterdeletionrecoveryisnotpossible: "삭제 후 복구는 불가능합니다.",
  managedata: "데이터 관리",
  aboutstyles: "스타일 정보",
  lines: "선(라인)",
  LineString: "선(라인)",
  NodeLink: "노드링크",
  Node: "노드",
  Link: "링크",
  linkdist: "연결거리",
  detectptdist: "기존 점 찾는 거리",
  svinfo: "거리뷰 정보",
  svedit: "지도모드",
  enteranameforyourstyle: "스타일명을 입력하세요",
  preview: "미리보기",
  facespolygons: "면(폴리곤)",
  Polygon: "면(폴리곤)",
  stylename: "스타일명",
  registeringdotmarkerstyles: "점(마커) 스타일 등록",
  enteranameforyourstyleupto50characters: "스타일명 입력하세요 (최대50자)",
  styletypes: "스타일 구분",
  selectapointmarkertype: "점(마커) 타입 선택",
  select_type: "타입 선택",
  ugh: "으",
  shape: "도형",
  dotmarkersize: "점(마커) 크기",
  bordercolorsize: "테두리 색상 / 크기",
  disable: "비활성화",
  whethertousetext: "텍스트 사용 여부",
  onoff: "ON/OFF",
  textcontent: "텍스트 내용",
  pleaseenteradescriptionupto50characters: "내용을 입력하세요 (최대50자)",
  fonts: "폰트",
  sunnygothic: "맑은고딕",
  styles: "스타일",
  fontcolorsize: "폰트 색상 / 크기",
  registeringlinestyles: "선(라인) 스타일 등록",
  linecolorsize: "선 색상 / 크기",
  fillcolor: "채움 색상",
  transparency: "투명도",
  sldstyledetails: "SLD 스타일 상세보기",
  nofilesareregistered: "등록된 파일이 없습니다.",
  registeringalayerroadview: "레이어 거리뷰 등록",
  registeringitems: "아이템 등록",
  datetaken: "촬영일자",
  selectadate: "날짜를 선택하세요",
  dotmarkerdetails: "점 (마커) 상세보기",
  linelineorder: "선(라인) 순번",
  pleaseentertheinformationorderisarequiredvalue:
    "정보를 입력하세요 순번은 필수 값입니다.",
  enterthedotmarkersequenceinformationthesequenceisarequiredvalue:
    "점(마커) 순번 정보를 입력하세요 순번은 필수 값입니다.",
  lists: "목록",
  tolist: "목록으로",
  addingitems: "아이템 추가",
  datamanagementroadview_memomanagement: "데이터 관리 > 거리뷰_메모관리",
  roadviewnoteslist: "거리뷰 메모 리스트",
  today: "오늘",
  memo: "메모",
  yesterday: "어제",
  author: "작성자",
  "7daysago": "~ 7일전",
  "30daysago": "~ 30일전",
  managemembersusers: "회원(사용자) 관리",
  manuallyenrollusers: "사용자 수동등록",
  manualcreation: "수동 생성",
  membershipnumber: "회원번호",
  man_member: "회원관리",
  mem_list: "회원리스트",
  adm_list: "관리자리스트",
  mem_detailinfo: "회원 상세정보",
  enteryourmemberidx: "회원 ID를 입력하세요",
  enteraname: "이름을 입력하세요",
  cellphones: "휴대폰",
  enteryourcellphonenumber: "휴대폰 번호를 입력하세요.",
  email: "이메일",
  sendingemail: "이메일 발송",
  enteryouremailaddress: "이메일 주소를 입력하세요",
  enter_email_with_register: "가입 시 등록된 이메일 주소를 입력해주세요",
  email_changed: "이메일 주소가 변경되었습니다",
  searchresults: "검색결과",
  accessibility: "접근여부",
  membershipclassification: "회원구분",
  id: "아이디",
  contact: "연락처",
  companyperiodname: "회사 / 기관명",
  joindate: "가입일",
  useraccess: "사용자 접근여부",
  accessible: "접근가능",
  username: "사용자명",
  countrycode: "국가코드",
  count: "갯수",
  pleaseenteryourtoverifyyourinformation:
    "아아디를 입력해 주세요 정보를 확인 해주세요",
  password: "비밀번호",
  oinaccessible: "접근불가",
  atemporarypasswordwillbeautomaticallysenttotheemailyouprovided:
    "비밀번호는 입력주신 이메일로 임시 비밀번호가 자동으로 발송됩니다.",
  pleaseenteraname: "이름을 입력해주세요",
  pleaseenteryourcompanyperiodnamepleaseconfirmyourinformation:
    "회사/기관명을 입력해 주세요 정보를 확인 해주세요",
  pleaseenteryourpriorityphoneorcellphonenumber:
    "유선전화 또는 휴대폰번호를 입력해 주세요",
  departmentname: "부서명",
  dept: "부서",
  upper_dept: "상위 부서",
  man_dept: "부서관리",
  depth: "깊이",
  pleaseenteradepartmentname: "부서명을 입력해주세요",
  jobtitle: "직책",
  jobtitlename: "직책명",
  man_jobtitle: "직책관리",
  pleaseenteryourjobtitle: "직책명을 입력해주세요",
  basicinformation: "기본정보",
  emailaddress: "이메일 주소",
  companyorganizationname: "회사 / 기관명",
  membershipdate: "회원 가입일",
  emailverificationtime: "이메일 인증시각",
  emailverificationcode: "이메일 인증코드",
  lastlogin: "마지막 로그인",
  marketingconsent: "마케팅 수신동의(선택)",
  marketingconsentsmssns: "마케팅 SMS, SNS 수신동의",
  alerttalktext: "알림톡 / 문자",
  listeningtime: "수신허용시간",
  inquiryapplicationhistory: "문의/신청내역",
  unprocessed: "미 처리",
  processed: "처리완료",
  shortcuts: "바로가기",
  helpcenter: "고객센터",
  gotocontactus: "문의바로가기",
  roadview_shootinginquiry: "거리뷰_촬영문의",
  applyforanopenapi: "오픈 API 신청",
  aboutdata: "데이터 정보",
  numberofdata: "데이터 수",
  filesize: "파일용량",
  roadview_notes: "거리뷰_나의메모",
  withdrawal: "회원탈퇴",
  attention: "주의하세요!",
  handler: "처리자",
  knowwhatinformationisdeletedretainedwhenyouunsubscribeoncedeleteditcantberecovered:
    "탈퇴시 삭제/유지되는 정보를 확인하세요 한번 삭제된 정보는 복구가 불가능합니다.",
  deleteaccountinformation: "계정정보 삭제",
  deleteinquiryhistory: "문의내역 삭제",
  deletingapiinformation: "API 정보 삭제",
  deletemynotes: "나의 메모 삭제",
  deleteasharedlayer: "공유 레이어 삭제",
  enteryourcurrentpassword: "현재 비밀번호 입력",
  enteryourpassword: "비밀번호를 입력해주세요",
  unadm: "관리자 해지",
  unadm_mem_detail: "관리자에서 해지하시겠습니까?",
  termination: "해지",
  man_admin: "관리자 관리",
  move_man_adm: "관리자 설정 이동",
  turnsoffadministratorprivilegesfortheselecteduser:
    "선택한 유저의 관리자 권한을 해제합니다.",
  no_permission: "권한이 없습니다.",
  no_required_data: "필수 데이터가 없습니다",
  no_save_data: "저장할 데이터가 없습니다",
  con_save_ttl: "저장 확인",
  subdata_exists: "하위 데이터가 존재합니다",
  addanadmin: "관리자 추가하기",
  authorities: "권한종류",
  adminscanbeaddedafterregularsignup:
    "관리자는 일반 회원가입 후 추가가 가능합니다.",
  notificationsettings: "알림설정",
  viewfulllogs: "전체 로그 보기",
  mapsettings: "지도설정",
  setcoordinatesystem: "좌표계설정",
  announcements: "공지사항",
  helpcentercontacthistory: "고객센터 문의내역",
  applytousetheopenapi: "오픈 API 사용신청",
  privacyconsent_required: "개인정보 수집 및 이용동의(필수)",
  privacyconsent_optional: "개인정보 수집 및 이용동의(선택)",
  privacyconsentok: "개인정보 수집 및 이용에 동의",
  termsofuse: "이용약관",
  maptype: "지도종류",
  defaultmapornot: "기본지도여부",
  mapdivisions: "지도구분",
  mapname: "지도명",
  maptypes: "지도종류",
  noregisteredbackgroundmaps: "등록된 배경지도가 없습니다",
  registermaps: "지도 등록",
  userlang: "사용자 언어",
  pleaseenteranameforyourmapupto50characters:
    "지도명을 입력해주세요 (최대 50자)",
  confirmyourentry: "입력 내용을 확인해주세요",
  aboutapikeys: "API 키 정보",
  apikey: "API 키",
  enteryoururlinformation: "URL 정보를 입력해주세요",
  defaultmapsettings: "기본지도 설정",
  basicmaps: "기본지도",
  settingthecoordinatesystem: "좌표계 설정",
  setupyourfavoritecoordinatesystem: "자주 사용하는 좌표계를 설정해보세요.",
  youcanadddeleteanycoordinatesystemyouwantatanytime:
    "원하시는 좌표계는 언제든 추가/삭제할 수 있습니다.",
  fulllist: "전체 리스트",
  frequentlyusedcoordinatesystems: "자주 사용하는 좌표계",
  save: "저장",
  noregisteredinquiries: "등록된 문의내역이 없습니다",
  helpcenter11inquiries: "고객센터 1:1 문의내역",
  categories: "카테고리",
  pleaseenteryoursearchterm: "검색어를 입력 해주세요.",
  status: "상태",
  wait: "대기",
  ongoing: "진행중",
  dateofenrollment: "등록일",
  dateofmod: "최종수정일",
  detailcontents: "상세내역",
  oneonone_inquery: "1:1 문의",
  processingqueue: "처리대기",
  viewinformation: "정보보기",
  inquirydetail: "문의내용",
  answer: "답변내용",
  answerer: "답변자",
  roadview_inquery: "거리뷰 촬영문의",
  desiredregion: "희망지역",
  intake: "접수",
  applicant: "신청자",
  applicationdate: "신청일자",
  issuer: "발급자",
  keyissuance: "키발급",
  reissuance: "재발급",
  publishedon: "게시일자",
  addnotice: "공지사항 등록",
  scheduling: "예약",
  ishidden: "숨김여부",
  exposure: "노출",
  hidden: "숨김",
  fixedtop: "상단고정여부",
  fixed: "고정",
  unfixed: "비고정",
  pleaseenteratitleupto50characters: "제목을 입력해주세요 (최대 50자)",
  pleaseconfirmyourentry: "입력 내용을 확인해주세요",
  enteradescriptionupto500characters: "내용을 입력하세요. (최대 500자)",
  effectivedate: "시행일자",
  version: "버전",
  registerterms: "약관등록",
  termsofservice: "서비스 이용약관",
  manserv: "서비스 관리",
  manserv: "서비스 관리",
  modifyterms: "약관수정",
  offer: "제의",
  termsandconditions: "약관내용",
  privacypolicy: "개인정보 취급방침",
  locationterms: "위치정보 서비스 이용약관",
  privacyconsentoptional: "개인정보 수집동의 (선택)",
  privacyconsent: "개인정보 수집동의",
  entercontent: "내용입력",
  purposeofcollectingandusingpersonalinformation:
    "개인정보의 수집 및 이용 목적",
  "2whatpersonalinformationdoyoucollect": "2.수집하는 개인정보 항목",
  consenttoreceivepromotionaladvertisinginformationoptional:
    "프로모션(광고) 정보 수신 동의 (선택)",
  selectapromotion: "프로모션 선택",
  consenttoreceiveemails: "이메일 수신 동의",
  measuresnecessarytoensurethesecurityofpersonalinformation:
    "개인정보의 안정성 확보에 필요한 조치에 관한 사항",
  memberinformationaccesshistory: "회원정보 접속기록",
  dateofaccess: "접속일시",
  connectionip: "접속 IP",
  adminname: "관리자 이름",
  accesspage: "접속페이지",
  personalinformation: "개인정보",
  downloadexcel: "엑셀 다운로드",
  whatyoudo: "수행업무",
  adminmenu: "관리자메뉴",
  servermonitoring: "서버모니터링",
  servertotaldiskcapacity: "서버 전체 디스크 용량",
  dataasawhole: "데이터 전체",
  year: "년도",
  usageamount: "사용용량",
  remainingamount: "남은용량",
  statusbydata: "데이터별 현황",
  datasize: "데이터 수",
  alarmsetting: "알림설정",
  alarmlist: "알림내역",
  man_tar: "대상자 관리",
  tar_list: "대상자 리스트",
  eventname: "이벤트명",
  shippingmethod: "발송수단",
  manageusers: "사용자 관리",
  loglist: "로그목록",
  processingnumber: "처리번호",
  processingtime: "처리시간",
  workers: "작업자",
  tasktypes: "작업 종류",
  linetypes: "선 종류",
  whatyoureworkingon: "작업 내용",
  taskstatustaskdetailsremarks: "작업 상태 작업 상세 (비고)",
  editmemberinformation: "회원정보수정",
  saveinfo: "정보저장",
  logout: "로그아웃",
  applyforanopenapikey: "OPEN API 키 신청",
  applyforanopenapikeycomplete: "OPEN API 키 신청완료",
  openapikeypublished: "OPEN API 키 발급완료",
  answered: "답변완료",
  waitingforananswer: "답변대기",
  openapikeyissuanceisrequired: "OPEN API 키 발급이 필요합니다.",
  openapikeyrequest: "OPEN API 키 발급 신청",
  applynow: "지금 바로 신청하세요",
  contactus11: "1:1문의하기",
  contactus: "문의하기",
  activated: "시행중",
  recentactions: "최근 작업내역",
  managemydata: "나의 데이터 관리",
  managemynotes: "나의 메모관리",
  sharedlayers: "공유한 레이어",
  proceedtosignout: "로그아웃을 진행합니다.",
  youretakentotheloginpage: "로그인 페이지로 이동합니다.",
  verifyyouropenapikey: "OPEN API 키 확인",
  aboutopenapikeys: "OPEN API 키 정보",
  copytheopenapikey: "OPEN API 키 복사하기",
  openapikeyissuanceapplicationcompleted: "OPEN API키 발급 신청완료",
  sharers: "공유자",
  viewonmap: "지도에서보기",
  therearecurrentlynoinquiries: "현재 문의하신 내역이 없습니다.",
  "11inquiryhistory": "1:1 문의내역",
  "11contactregisterlearnmore": "1:1문의 > 등록 / 상세보기",
  fileattachments: "파일첨부",
  changeyourpassword: "비밀번호 변경",
  nochangeyourpassword: "비밀번호 변경 안함",
  pw_changed: "비밀번호가 변경되었습니다.",
  currentpassword: "현재 비밀번호",
  pleaseenteryourpassword: "비밀번호를 입력해주세요",
  pleaseconfirmyourpassword: "비밀번호를 확인해주세요",
  newpassword: "새로운 비밀번호",
  confirmpassword: "비밀번호 확인",
  checksamepasscon: "동일한 비밀번호를 입력해주세요.",
  findpasswd: "비밀번호 찾기",
  character: "문자",
  optin: "수신 동의",
  back: "뒤로가기",
  changeyouremail: "이메일 변경하기",
  entertheemailaddressyoudliketochange:
    "변경을 원하는 이메일 주소를 입력해주세요",
  pleaseenteryouremailaddress: "이메일주소를 입력해주세요",
  pleasecheckthericecakeinformation: "힘떡 정보를 확인 해주세요",
  sendanauthorizationnumber: "인증번호발송",
  enteryourverificationnumber: "인증번호 입력",
  pleaseenteryourverificationnumber: "인증번호를 입력해주세요",
  resend: "재전송",
  didNotReceiveCode: "코드를 받지 못하셧습니까?",
  signin: "로그인",
  pleaseconfirmtheinformationyouentered: "입력 정보를 확인 해주세요.",
  forgotyourpassword: "비밀번호를 잊으셨나요?",
  notamemberyet: "아직 회원이 아니신가요?",
  pleasechangeyourpasswordtoprotectyourprivacy:
    "개인정보 보호를 위해 비밀번호를 변경해주세요",
  enteranewpassword: "새 비밀번호 입력",
  confirmyournewpassword: "새 비밀번호 확인",
  passwordsafetyrules: "비밀번호 안전규칙",
  lettermin8: "8자 이상으로 입력해 주세요",
  at_least_two_of_the_following:
    "영문 대/소문자, 숫자, 특수문자 중 2가지 이상 사용 해야 합니다",
  useatleast8charactersandatleasttwoofthefollowingupperandlowercaselettersnumbersandspecialcharacters:
    "8자이상 영문 대/소문자, 숫자, 특수문자 중 2가지 이상 사용",
  nomorethan4consecutivecharactersdigitsofthesameletternumber1111aaaetc:
    "동일한 문자(숫자), 연속적인 숫자 4자이상 사용불가 (1111, aaa등)",
  cantusemorethan3charactersonthekeyboardqweretc:
    "키보드 상의 3글자 이상을 사용불가 (qwer 등)",
  previouslyusedpasswordsaredisabled: "이전에 사용한 비밀번호 사용불가",
  avoidusingthesamenumberasyourdateofbirthandphonenumber:
    "생년월일, 전화번호와 동일한 번호는 사용 자제.",
  makingchanges: "변경하기",
  makingchangesafter30days: "30일뒤에 변경하기",
  signup: "회원가입",
  enterinformation: "정보입력",
  emailauthentication: "이메일 인증",
  acceptterms: "약관동의",
  hello: "안녕하세요",
  pleaseacceptthetermstosignupforsite:
    "_sitename_에 가입하시려면 약관에 동의해 주세요.",
  acceptthetermsintheirentiretyincludingoptinconsent:
    "약관 전체 동의하기 (선택 동의 포함)",
  agreeandenteryourinformation: "동의하고 정보입력",
  viewall: "전체보기",
  pleaseenteryourid: "아이디를 입력해주세요",
  pleaseenteryouremail: "이메일을 입력해주세요",
  check_id_or_passwd: "아이디/비밀번호를 확인해주세요",
  pleasecheckyourpasswordsafetyrules: "비밀번호 안전규칙을 확인해 주세요",
  pleaseenteryourpasswordonemoretime: "비밀번호를 한번 더 입력해 주세요",
  pleaseenteryourcompanyperiodname: "회사/기관명을 입력해주세요",
  pleaseenteryourlandlineorcellphonenumber:
    "유선전화 또는 휴대폰번호를 입력해주세요",
  id_email_already_taken: "이미 존재하는 아이디/이메일 입니다",
  nm_already_taken: "이미 존재하는 이름 입니다",
  jobttl_already_taken: "이미 존재하는 직책 입니다",
  email_already_taken: "이미 존재하는 이메일 입니다",
  email_not_exist: "존재하지 않는 이메일 입니다",
  mem_not_exist: "존재하지 않는 사용자 입니다",
  data_not_exist: "존재하지 않는 데이터 입니다",
  server_error: "서버 에러",
  nondatesafetyruleo: "비일번호 안전규칙 O",
  informationpower: "정보입력",
  wrong_verification_code: "올바른 인증번호가 아닙니다.",
  wrong_passwd: "올바른 비밀번호가 아닙니다.",
  wrong_url: "올바른 URL이 아닙니다.",
  wrong_sld: "It is not a valid SLD.",
  wrong_extent: "It is not a valid Extent.",
  authcode: "인증코드",
  verification_code_confirmation: "인증번호가 확인되었습니다.",
  wehavesentaverificationnumbertotheemailyouprovided:
    "이메일로 인증번호를 발송하였습니다.",
  entertheverificationnumberintheemailyoureceived:
    "수신된 이메일로 인증번호를 입력해주세요",
  imailauthentication: "이메일 인증",
  yoursignupiscomplete: "회원가입이 완료되었습니다.",
  authenticate: "인증하기",
  gotohome: "홈으로 가기",
  wevesentaverificationnumbertotheemailyouprovided:
    "입력하신 이메일로 인증번호를 발송하였습니다.",
  pleasealsocheckforsparklesorpromotions:
    "스팸함 또는 프로모션도 확인 해주세요",
  enteryournewpassword: "새 비밀번호 입력!",
  signedup: "신청완료",
  pleaseconfirmtheverificationnumberbelowtocompleteemailverification:
    "아래 인증번호를 확인하여 이메일 인증을 완료해 주세요",
  openapiapproved: "OPEN API 승인완료",
  openapiauthorizationiscomplete: "OPEN API 승인이 완료되었습니다.",
  theopenapiauthorizationyourequestedwassuccessfullycompleted:
    "신청하신 OPEN API 승인이 정상적으로 완료되었습니다.",
  youarenowfreetouseallthefeatures:
    "이제 고객님께서는 모든 기능을 자유롭게 이용하실 수 있습니다.",
  yourapikeyis: "고객님의 API 키는 다음과 같습니다.",
  eojdhjoc: "eoj#dhjoc",
  temporarypasswordinstructions: "임시 비밀번호 안내",
  atemporarypasswordhasbeengenerated: "임시 비밀번호가 생성되었습니다.",
  signinwithyourtemporarypasswordbelow: "아래의 임시 비밀번호로 로그인하세요",
  temporarypasswords: "임시 비밀번호",
  openapis: "오픈API",
  page: "페이지",
  api: "API",
  complete: "완료",
  inquery_completed: "문의완료",
  inquery_received: "문의가 접수되었습니다",
  passwordguidepopup: "비밀번호 가이드 팝업",
  pleasealsocheckyourspamorpromotionalinboxes:
    "스팸함 또는 프로모션함도 확인 해주세요.",
  newgroups: "신규 그룹",
  editthegroupname: "그룹명 수정",
  yourenotallowedtologinduetoanoperatingpolicyviolation:
    "운영정책 위반으로 로그인이 불가합니다.",
  contactyouradministrator: "관리자에게 문의해 주세요",
  saveorder: "순서저장",
  saveinthecurrentorder: "현재 순서로 저장합니다.",
  allassociateddatawilldisappear: "관련 데이터가 모두 사라집니다.",
  no_spitial_data: "공간데이터가 존재하지 않습니다.",
  issuingapikeys: "API 키발급",
  issueapikeystotheselectedcustomers: "선택한 고객에게 API 키를 발급합니다.",
  issueatemporarypassword: "임시 비밀번호 발급",
  emailatemporarypassword: "임시 비밀번호를 이메일로 발송합니다.",
  existingbillnumberswillbereset: "기존 비빌번호는 초기화 됩니다.",
  newlayername: "신규 레이어명",
  youllbetakentotheloginpagetologin: "로그인을 위해 로그인 페이로 이동합니다.",
  reorder: "순서변경",
  toastphrases: "토스트 문구",
  tasksuccess: "작업성공",
  savesuccessful: "저장 성공",
  save_con: "저장하시겠습니까?",
  mod_con: "수정하시겠습니까?",
  thesaveiscomplete: "저장이 완료되었습니다.",
  updatesuccessful: "업데이트 성공",
  theupdateiscomplete: "업데이트가 완료되었습니다.",
  successfultransfer: "전송 성공",
  thetransferiscomplete: "전송이 완료되었습니다.",
  successfuldeletion: "삭제 성공",
  thedeletioniscomplete: "삭제가 완료되었습니다.",
  typicalsuccess: "일반적인 성공",
  itwasprocessedsuccessfully: "정상적으로 처리되었습니다.",
  taskfailed: "작업실패",
  savefailed: "저장실패",
  anerroroccurredwhilesavingpleasetryagaininamoment:
    "저장 중 오류가 발생하였습니다. 잠시 후 다시 시도해주세요.",
  updatefailed: "업데이트 실패",
  theupdatefailedpleasetryagaininamoment:
    "업데이트를 실패했습니다. 잠시 후 다시 시도해주세요.",
  transferfailure: "전송 실패",
  anerroroccurredwhileprocessingtherequest: "요청 처리 중 오류가 발생했습니다.",
  deletefailed: "삭제 실패",
  thedeletefailedpleasetryagaininamoment:
    "삭제를 실패했습니다. 잠시 후 다시 시도해주세요.",
  del_con: "삭제하시겠습니까?",
  commonfailures: "일반적인 실패",
  somethingwentwrongpleasecontactyouradministratorerrorcode:
    "문제가 발생했습니다. 관리자에게 문의해주세요. (오류코드)",
  apiintegrationconnectionissues: "API 연동 연결문제",
  anunexpectedproblemhasoccurredpleasecontactyouradministratorerrorcode:
    "예상치 못한 문제가 발생했습니다. 관리자에게 문의해주세요. (오류코드)",
  failedtoloaddata: "데이터 로딩 실패",
  failedtoloaddatapleasecontactyouradministratorerrorcode:
    "데이터를 불러오는 못하였습니다. 관리자에게 문의해주세요. (오류코드)",
  pagenotfound: "페이지를 찾을 수 없습니다.",
  login: "로그인",
  lastlogindt: "마지막 로그인시각",
  gotologin: "로그인 하러 가기",
  passwd: "비밀번호",
  lastpasswd: "이전 비밀번호",
  forgotpasswd: "패스워드를 잊어버리셨나요?",
  loginsucc: "로그인 성공",
  welcome_mem: "어서오세요 _mem_님",
  loginfail: "로그인에 실패 했습니다",
  emailnotvalid: "유효한 이메일 주소를 입력 해 주세요.",
  requiredfield: "필수 입력 필드 입니다.",
  invalidtoken: "유효한 토큰이 아닙니다",
  invalidtxtcontain: "유효하지 않은 문자가 포함되어 있습니다",
  disabled: "접근여부",
  needchangepw: "비밀번호 변경 필요 여부",
  uid: "고유번호",
  authdt: "인증일",
  authsentdt: "인증번호 발송일",
  cannot_mod_del: "수정/삭제 할 수 없습니다",
  logtype: "로그종류",
  logstatus: "로그상태",
  execute: "실행",
  sendfiletoserver: "서버로 파일 전송",
  executorid: "실행자아이디",
  executornm: "실행자이름",
  targetid: "대상아이디",
  createrid: "생성아이디",
  modifierid: "수정아이디",
  targetnm: "대상이름",
  logcate: "로그카테고리",
  pval: "이전값",
  nval: "변경값",
  logmsg: "로그메시지",
  ip: "아이피주소",
  select_range: "기간 선택",
  set_log_lim: "로그 저장기간 설정",
  set_log_lim_guide: "로그 기록을 저장할 기간을 선택해주세요.",
  wrong_mem_info: "사용자 정보가 올바르지 않습니다",
  wrong_mem_id: "아이디가 올바르지 않습니다",
  wrong_mem_pass: "비밀번호가 올바르지 않습니다",
  wrong_sld: "올바른 SLD 가 아닙니다",
  wrong_extent: "Extent가 올바르지 않습니다",
  etc: "기타",
  etc_config: "기타 설정",
  unlimited: "무제한",
  years: "년",
  months: "개월",
  sel_mem: "회원 선택",
  site_nm: "사이트명",
  sel_tar_con: "대상을 선택해 주세요",
  sysconf: "시스템 설정",
  copied: "복사되었습니다",
  man_com_info: "회사 정보 관리",
  set_map_pos: "지도 위치 설정",
  com_nm: "회사명",
  com_addr: "회사주소",
  sys: "시스템",
  conf: "설정",
  osm: "OSM",
  tilex: "tile X",
  tiley: "tile Y",
  tilez: "tile Z",
  plzent_lbl_: "_lbl_ 값을 입력해 주세요",
  del_lbl_conttl: "_lbl_ 삭제 확인",
  refresh: "새로고침",
  extension: "확장자",
  roadview_price_inquery: "거리뷰 촬영견적문의",
  sms: "SMS",
  kakaotalk: "카카오톡",
  slack: "Slack",
  public_access: "전체 공개",
  partial_access: "부분 공개",
  no_access: "비공개",
  all: "전체",
  partial: "일부",
  none: "없음",
  none: "없음",
  access_setting: "공개 설정",
  read: "조회",
  con_pt: "포인트 연결 하기",
  discon_pt: "포인트 연결 해제",
  success: "성공",
  fail: "실패",
  ongoing: "진행 중",
  cancel_by_user: "사용자 취소",
  cancel_by_system: "시스템 취소",
  uploading: "업로드 중",
  uploaded: "업로드 완료",
  processing: "처리 중",
  processed: "처리 완료",
  auto: "자동",
  noimg: "이미지가 없습니다",
  oid: "객체탐지ID",
  thumbnail: "섬네일",
  cls: "유형",
  ocr: "OCR",
  latitude: "위도",
  longitude: "경도",
  im_date: "촬영일자",
  im_id: "거리뷰 이미지번호",
  proc_date: "검출일자",
  model_ver: "모델버전",
  extlink: "외부링크",
};
